import AuditLogService from "@/services/AuditLogService";

const INITIAL_PAGINATION = {
  pageIndex: 0,
  pageSize: 0,
  totalElements: 0,
  totalPages: 0
}

const state = {
  auditLogRates: [],
  auditLogRatesPagination: { ...INITIAL_PAGINATION },
  auditLogFees: [],
  auditLogFeesPagination: { ...INITIAL_PAGINATION },
  auditLogPayout: [],
  auditLogPayoutPagination: { ...INITIAL_PAGINATION }
}

const mutations = {
  setAuditLogRates (state, value) {
    state.auditLogRates = value;
  },

  setAuditLogRatesPagination (state, value) {
    state.auditLogRatesPagination = value;
  },

  setAuditLogFees (state, value) {
    state.auditLogFees = value;
  },

  setAuditLogFeesPagination (state, value) {
    state.auditLogFeesPagination = value;
  },

  setAuditLogPayout (state, value) {
    state.auditLogPayout = value;
  },

  setAuditLogPayoutPagination (state, value) {
    state.auditLogPayoutPagination = value;
  },
}

const getters = {
  auditLogRates: state => state.auditLogRates,
  auditLogRatesPagination: state => state.auditLogRatesPagination,
  auditLogFees: state => state.auditLogFees,
  auditLogFeesPagination: state => state.auditLogFeesPagination,
  auditLogPayout: state => state.auditLogPayout,
  auditLogPayoutPagination: state => state.auditLogPayoutPagination
}

const actions = {
  async getAuditLogRates ({commit}, payload) {
    try {
      const { list, pagination } = await AuditLogService.getAuditLogRates(payload);
      commit("setAuditLogRates", list);
      commit("setAuditLogRatesPagination", pagination);
    } catch (error) {
      commit("setAuditLogRates", []);
      commit("setAuditLogRatesPagination", INITIAL_PAGINATION);
    }
  },

  async getAuditLogFees ({commit}, payload) {
    try {
      const { list, pagination } = await AuditLogService.getAuditLogFees(payload);
      commit("setAuditLogFees", list);
      commit("setAuditLogFeesPagination", pagination);
    } catch (error) {
      commit("setAuditLogFees", []);
      commit("setAuditLogFeesPagination", INITIAL_PAGINATION);
    }
  },

  async getAuditLogPayout ({commit}, payload) {
    try {
      const { list, pagination } = await AuditLogService.getAuditLogPayoutPartnerRates(payload);
      commit("setAuditLogPayout", list);
      commit("setAuditLogPayoutPagination", pagination);
    } catch (error) {
      commit("setAuditLogPayout", []);
      commit("setAuditLogPayoutPagination", INITIAL_PAGINATION);
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
